const PrivacyPolicyContent = ({contentConfig}:any) => {
  return (
    <div>
      <div className=" mb-2 text-sm">
        This Privacy Policy describes how{' '}
        <span className=" font-extrabold">{contentConfig?.universityName}</span>{' '}
        ("we," "us," or "our") collects, uses, and discloses information
        obtained from users of the {contentConfig?.systemName}. By
        accessing or using the LMS, you consent to the collection, use, and
        disclosure of your information as described in this Privacy Policy.
      </div>
      <div className="  mb-2 font-bold">Information Collection and Use</div>
      <div className=" text-sm">
        We may collect personal information such as your name, email address,
        and other relevant details when you register for an account on the LMS.
        We use this information to provide you with access to the LMS and its
        features, communicate with you, and improve our services.
      </div>
      <div className=" mb-2 mt-4 font-bold ">Log Data</div>
      <div className=" text-sm">
        We may also collect information that your browser sends whenever you
        visit the LMS ("Log Data"). This Log Data may include information such
        as your computer's Internet Protocol ("IP") address, browser type,
        browser version, the pages of the LMS that you visit, the time and date
        of your visit, the time spent on those pages, and other statistics. We
        use this information to analyze trends, administer the site, track
        users' movements around the site, and gather demographic information.
      </div>
      <div className=" mb-2 mt-4 font-bold">Cookies</div>
      <div className=" text-sm">
        We use cookies to collect information and improve our services. You can
        instruct your browser to refuse all cookies or to indicate when a cookie
        is being sent. However, if you do not accept cookies, you may not be
        able to use some portions of the LMS.
        <div className="mb-2 mt-4 font-bold">Third-Party Services</div>
        We may use third-party services such as analytics tools to help us
        analyze how users interact with the LMS. These third-party service
        providers may collect information sent by your browser as part of a web
        page request, such as cookies or your IP address.
      </div>
      <div className="mb-2 mt-4 font-bold">Data Security</div>
      <div className=" text-sm">
        We take appropriate measures to protect the security of your personal
        information and strive to ensure that it is treated securely and in
        accordance with this Privacy Policy. However, no method of transmission
        over the Internet or electronic storage is 100% secure, so we cannot
        guarantee its absolute security.
      </div>
      <div className="mb-2 mt-4 font-bold">Changes to this Privacy Policy</div>
      <div className=" text-sm">
        We reserve the right to update or change our Privacy Policy at any time.
        Any changes will be effective immediately upon posting the updated
        Privacy Policy on the LMS. You are advised to review this Privacy Policy
        periodically for any changes.
      </div>
      <div className="mb-2 mt-4 font-bold">Contact Us</div>
      <div className=" my-2 text-sm">
        If you have any questions about this Privacy Policy, please contact us
        at [{contentConfig?.supportEmail}].
      </div>
      <div className=" my-2 text-sm">
        By accessing or using the LMS, you acknowledge that you have read,
        understood, and agree to be bound by this Privacy Policy.`,
      </div>
    </div>
  )
}

export default PrivacyPolicyContent
